import { isEmpty } from "lodash";
import { useFormContext } from "react-hook-form";

export function useGetShouldUpdateField<T extends Record<string, any>>() {
  const { getValues, getFieldState } = useFormContext<T>();

  return {
    shouldUpdateField(name: Parameters<typeof getFieldState>[0]) {
      // this function should only update field if field deosn't have any value, and was not modified or touched by user
      if (!isEmpty(getValues(name))) return false;
      if (getFieldState(name).isDirty || getFieldState(name).isTouched)
        return false;

      return true;
    },
  };
}
